import { render, staticRenderFns } from "./NewTabLink.vue?vue&type=template&id=10c5e65a"
import script from "./NewTabLink.vue?vue&type=script&lang=ts"
export * from "./NewTabLink.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('10c5e65a')) {
      api.createRecord('10c5e65a', component.options)
    } else {
      api.reload('10c5e65a', component.options)
    }
    module.hot.accept("./NewTabLink.vue?vue&type=template&id=10c5e65a", function () {
      api.rerender('10c5e65a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/NewTabLink.vue"
export default component.exports